import { render, staticRenderFns } from "./project-permitting.vue?vue&type=template&id=51f87438&scoped=true"
import script from "./project-permitting.vue?vue&type=script&lang=js"
export * from "./project-permitting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f87438",
  null
  
)

export default component.exports